import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../../environments/environment';

/**
 * @class TrackingService
 * This is a wrapper around the GoogleTagManagerService (and potentially other tracking services).
 * It implements environment-specific tracking disabling.
 */
@Injectable({ providedIn: 'root' })
export class TrackingService {
    constructor(private readonly gtmService: GoogleTagManagerService) {}

    public async pushGtmTag(gtmTag: object): Promise<void> {
        if (!environment.trackingEnabled) {
            return;
        }
        return this.gtmService.pushTag(gtmTag);
    }
}
